module.exports = __webpack_public_path__ + "img/logo-black.7351a463.png";